import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./LibraryLessonCardTop.module.scss";
import {CardStars, CardStarsValueType} from "../card-stars/CardStars";
import {LibraryLessonCardNumber} from "../library-lesson-card-number/LibraryLessonCardNumber";
import {LibraryLessonCardAmountComplete} from "../library-lesson-card-amount-complete/LibraryLessonCardAmountComplete";
import {LibraryLessonCardFavoriteAction} from "../library-lesson-card-favorite-action/LibraryLessonCardFavoriteAction";

export interface ILibraryLessonCardTopProps {
  lessonId: number;
  isFavorite?: boolean;
  number?: number | string;
  stars?: number;
  amountComplete?: number | string;
}

export const LibraryLessonCardTop: VoidFunctionComponent<ILibraryLessonCardTopProps> = ({lessonId, isFavorite, number, amountComplete, stars}) => {
  if (isFavorite === undefined && number === undefined && amountComplete === undefined && stars === undefined) {
    return null;
  }

  return (
    <div className={s.cardTop}>
      <LibraryLessonCardFavoriteAction {...{lessonId, isFavorite}} />
      <LibraryLessonCardNumber value={number}/>
      <CardStars value={stars as CardStarsValueType} min={1}/>
      <LibraryLessonCardAmountComplete value={amountComplete} />
      &nbsp;
    </div>
  );
}
